import { KazakhstanPage } from 'pageModules/KazakhstanPage';

export default KazakhstanPage;
